import datepickerFactory from 'jquery-datepicker';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-fr';
import moment from 'moment'

// Just pass your jquery instance and you're done
datepickerFactory($);
datepickerJAFactory($);
jQuery(document).ready(function ($) {
  // try to set domain opening date as minDate (ignore passed date)
  let minDate = ''
  if (typeof combellesVars.openingDate !== 'undefined') {
    if (new Date(combellesVars.openingDate).getTime() > new Date().getTime()) {
      minDate = combellesVars.openingDate
    }
  }

  const minDateObj = new Date(minDate)
  const minDays = 1
  const defaultDepartureDays = 2
  const minDateFormat = 'YYYY/MM/DD'
  const datepickerFormat = 'DD/MM/YYYY'
  const thelisFormat = 'YYYY-MM-DD'

  const bookingFormEl = document.querySelector('.booking-form')
  if (bookingFormEl) {
    bookingFormEl.addEventListener('formdata', (e) => {
      const formData = e.formData
      formData.set('begin', moment(formData.get('begin'), datepickerFormat).format(thelisFormat))
      formData.set('end', moment(formData.get('end'), datepickerFormat).format(thelisFormat))
    })
  }

  let args = {
    minDate: minDateObj,
    dateFormat: 'dd/mm/yy',
    prevText: '<i class="fa fa-angle-left"></i>',
    nextText: '<i class="fa fa-angle-right"></i>',
    onSelect: function (selectedDate, datepicker) {
      if ('arrivalDate' === datepicker.id) {
        const departureDateEl = $('#departureDate')
        const arrivalDate = moment(selectedDate, datepickerFormat)
        let departureDate = departureDateEl.val() ? departureDateEl.val() : selectedDate
        departureDate = moment(departureDate, datepickerFormat)

        // TEMP
        console.log('departureDate', departureDate)

        // make sure departure date is set to arrival date + minDays
        if (departureDate.diff(arrivalDate, 'days') < minDays) {
          departureDate = moment(selectedDate, datepickerFormat).add(minDays, 'days')
          departureDateEl.datepicker('setDate', departureDate.format(datepickerFormat))
        }

        // also update departure's minDate to arrival date + minDays
        departureDateEl.datepicker('option', 'minDate', arrivalDate.add(minDays, 'days').format(datepickerFormat))
      }
    }
  }

  // initialize arrival datepicker with default parameters
  $('#arrivalDate').datepicker(args).datepicker('setDate', minDateObj)

  // initialize departure datepicker with minDate set to arrival date + minDays
  const defaultArrivalDate = moment(minDate, minDateFormat)
  args.minDate = defaultArrivalDate.add(minDays, 'days').format(datepickerFormat)
  const defaultDepartureDate = moment(minDate).add(defaultDepartureDays, 'days').format(datepickerFormat)
  $('#departureDate').datepicker(args).datepicker('setDate', defaultDepartureDate)
})
